import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import Loader from "examples/Loader";
import "./style.css";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import Tabs from "../components/Tabs";
import PageLayout from "examples/LayoutContainers/PageLayout";
import SoftTypography from "components/SoftTypography";
import breakpoints from "assets/theme/base/breakpoints";
import editIcon from "../../../assets/themeIcons/edit-icon.svg"
import deleteIcon from "../../../assets/themeIcons/delete-icon.svg";
import nextIcon from '../../../assets/themeIcons/next.svg'
import previousIcon from '../../../assets/themeIcons/previous.svg'
import toast from "react-hot-toast";

function Accounts() {
  const { values } = breakpoints;
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [List, setList] = useState([]);
  const [loader, setloader] = useState(true);
  const onLoad = async () => {
    const { response } = await AppService.accounts.get({
      query: `agency_id=${agency._id}&tags=consumer`,
      toaster: false,
    });
    console.log("response", response?.data);
    if (response) {
      setList(response.data);
      setloader(false);
    } else {
      setList([]);
      setloader(false);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <PageLayout>
      <SoftBox alignItems="center">
        <div className="d-flex justify-content-between w-100">
          <div className="w-75 position-relative">
            <SoftTypography
              variant={window.innerWidth < values.sm ? "h3" : "h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Consumers
            </SoftTypography>
          </div>
          {/* <div className="w-25 text-end">
            <CreateModal products={products} apps={apps} handleRefresh={onLoad} />
          </div> */}
        </div>
        <Tabs
          tabsData={[
            {
              label: `All Consumers (${List?.length})`,
              content: <NewTable data={List.length > 0 && List} handleRefresh={onLoad} />,
            },
            // {
            //   label: `Premium Consumers (${List?.filter((item) => item?.plan_type === "premium").length
            //     })`,
            //   content: (
            //     <NewTable
            //       data={List.length > 0 && List.filter((item) => item?.plan_type === "premium")}
            //     />
            //   ),
            // },
            // {
            //   label: `Free Consumers (${List?.filter((item) => item?.plan_type === "free").length
            //     })`,
            //   content: (
            //     <NewTable
            //       data={List.length > 0 && List.filter((item) => item?.plan_type === "free")}
            //     />
            //   ),
            // },
          ]}
        />
      </SoftBox>
    </PageLayout>
  );
}

const NewTable = ({ data, handleRefresh }) => {
  const navigate = useNavigate();
  const AppService = useAppServices();
  if (!Array.isArray(data)) {
    return <p className="text-center">No record found ...</p>;
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const itemsPerPage = 10; // Number of items per page

  // Filter data based on the search query
  const filteredData = data.filter((item) =>
    item?.first_name?.toLowerCase()?.includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const maxButtonsToShow = 5; // Number of pagination buttons to display at a time

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const DeleteConsumer = async (id) => {
    const payload = {
      id: id,
    };
    const { response } = await AppService.accounts.DeleteConsumer({
      payload,
      toaster: true,
    });
    if (response) {
      toast.success("Consumer tag removed successfully");
      handleRefresh();
    }
  }


  // Calculate start and end of pagination buttons
  const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
  const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

  const tableTHStyles = {
    fontFamily: 'Poppins',
    fontWeight: 600,
  }


  console.log("currentItems", currentItems)

  return (
    <>
      {/* Search Input */}
      <div
        style={{
          position: "relative",
          marginBottom: "20px",
          display: "flex",
          width: "30%",
          float: "right",
        }}
      >
        <div style={{ position: "absolute", left: "10px", top: "20px" }}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_282_92)">
              <path
                d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                fill="#E5E5E5"
              />
            </g>
            <defs>
              <clipPath id="clip0_282_92">
                <rect width="15" height="15" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <input
          type="text"
          placeholder="Search by name..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            padding: "30px 45px",
            width: "100%",
            fontSize: "18px",
            boxSizing: "border-box",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        />
      </div>

      {/* Table Layout */}
      <table className="table w-100" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: '#F7F7F7', borderRadius: '18px' }}>
            <th className="p-20-px text-left" style={{ ...tableTHStyles, borderBottomLeftRadius: '18px', borderTopLeftRadius: '18px' }}>Name</th>
            <th className="p-20-px text-left" style={tableTHStyles}>Type</th>
            <th className="p-20-px text-left" style={tableTHStyles}>Status</th>
            <th className="p-20-px text-left" style={tableTHStyles}>Address</th>
            <th className="p-20-px text-left" style={tableTHStyles}>Phone #</th>
            <th className="p-20-px text-left" style={tableTHStyles}>Claimed Listings</th>

            <th className="p-20-px text-left" style={{ ...tableTHStyles, borderBottomRightRadius: '18px', borderTopRightRadius: '18px' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentItems?.length > 0 ? (
            currentItems?.map((item, index) => (
              <tr
                key={index}
                style={{ cursor: "pointer", borderBottom: '1px solid #DDDDDD' }}
              >
                <td className="p-20-px">{item?.first_name} {item?.last_name}</td>
                <td className="p-20-px">
                  <span>{item?.type === "premium" ? item?.type : "Free"}</span>
                </td>
                <td className="p-20-px">{item?.status}</td>
                <td className="p-20-px">{item?.address || ""}</td>
                <td className="p-20-px">{item?.phone_number}</td>
                <td className="p-20-px">{item?.claimCount}</td>
                <td className="p-20-px">
                  <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <img onClick={() => navigate(`../consumer-detail/${item.id}`)} width={20} src={editIcon} />
                    <img onClick={() => DeleteConsumer(item?.id)} width={20} src={deleteIcon} />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center">
                No accounts found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "none",
            borderRadius: "100px",
            boxShadow: '0px 1px 4px 0px #181A2012',
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            opacity: currentPage === 1 ? 0.6 : 1,
          }}
        >
          <img src={previousIcon} />
        </button>

        {[...Array(endPage - startPage + 1)].map((_, index) => {
          const pageNumber = startPage + index;
          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              style={{
                padding: "8px 16px",
                margin: "0 5px",
                backgroundColor: pageNumber === currentPage ? "#EB6753" : "white",
                color: pageNumber === currentPage ? "white" : "black",
                border: 'none',
                borderRadius: "100px",
                cursor: "pointer",
              }}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "none",
            boxShadow: '0px 1px 4px 0px #181A2012',
            borderRadius: "100px",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            opacity: currentPage === totalPages ? 0.6 : 1,
          }}
        >
          <img src={nextIcon} />
        </button>
      </div>
    </>
  );
};

export default Accounts;
